import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { NewsCO } from 'src/app/shared/models/ApiModels';

export interface NewsNoticeItem {
  id?: number;
  title: string;
  description?: string;
  date: string;
  link?: string;
  image?: any;
  isNew?: boolean;

  originalNews?: NewsCO;
}


@Component({
  selector: 'app-news-notice-overlay-v2',
  templateUrl: './news-notice-overlay-v2.component.html',
  styleUrls: ['./news-notice-overlay-v2.component.scss']
})
export class NewsNoticeOverlayV2Component
  implements OnInit, OnDestroy, OnChanges {

  @Input() newsList: NewsNoticeItem[] = [];
  @Input() newsHeaderBackground: any;
  @Input() newsHeaderColor: any;
  @Input() newsHeaderText: any;

  displayList: NewsNoticeItem[] = [];
  sliderTransition = true;

  currentIndex = 0;
  paused = false;

  private timer: any;

  constructor(
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const news = changes['newsList']?.currentValue ?? [];

    if (news.length <= 2) {
      this.displayList = [...news];
      this.currentIndex = 0;
    } else {
      this.displayList = [
        ...news,
        ...news,
        ...news
      ];

      this.currentIndex = news.length;
    }
  }

  ngOnInit(): void {
    this.timer = setInterval(() => {

      if (this.paused || this.newsList.length <= 2) {
        return;
      }

      this.currentIndex++;

      if (this.currentIndex >= this.newsList.length * 2) {

        setTimeout(() => {

          this.sliderTransition = false;
          this.currentIndex = this.newsList.length;

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.sliderTransition = true;
            });
          });

        }, 800);

      }

    }, 3000);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

  pause(): void {
    this.paused = true;
  }

  resume(): void {
    this.paused = false;
  }

  get transformValue(): string {
    return `translateY(-${this.currentIndex * 125}px)`;
  }

  viewAll(): void {
    console.log('View All Clicked');
    this.router.navigate(['news']);
  }

goToFullNews(news: NewsNoticeItem): void {
  if (!news?.id) {
    return;
  }

  sessionStorage.setItem(
    'selectedNews',
    JSON.stringify(news.originalNews ?? news)
  );

  this.router.navigate(
    ['newspage1'],
    {
      queryParams: {
        newsId: news.id
      }
    }
  );
}
}
